import React from 'react'
import Common_Images_Transport from '../../../common/common_imges_transport/Common_Images_Transport'
import { Link } from 'react-router-dom'

const Similar_Daily_Horoscope = () => {
    return (
        <div className="w-full grid grid-cols-2 md:grid-cols-4 lg:grid-cols-4 gap-3 mt-4">
            <div className="gi-product-content">
                <div
                    className="gi-product-inner transition-all duration-[0.3s] ease-in-out cursor-pointer overflow-hidden rounded-[5px] bg-white shadow-xl pt-4">
                    <div className="gi-pro-image-outer transition-all duration-[0.3s] delay-[0s] ease z-[11] relative">
                        <div className="gi-pro-image overflow-hidden pt-4 m-auto w-[120px] h-[120px]">
                            <Link to="/daily-horoscope-details"
                                className="image productimg7 relative block overflow-hidden pointer-events-none">
                                <img className="main-image max-w-full transition-all duration-[0.3s] ease delay-[0s]"
                                    src={Common_Images_Transport?.Aries} alt="Product" />
                            </Link>
                        </div>
                    </div>
                    <div className="gi-pro-content h-full p-[20px] relative z-[10] flex flex-col text-center">

                        <Link to="/daily-horoscope-details">
                            <h5
                                className="gi-pro-stitle text-lg text-gray-900 font-semibold leading-[1.2] capitalize">
                                Aries</h5>
                        </Link>
                        <p className="text-gray-700 font-medium text-[13px] leading-5 my-2 line-clamp-3">
                            Hey there, fiery Aries! Get ready to rock 2024 with unstoppable energy and fierce
                            determination. Your Aries Horoscope 2024 is a sneak peek into a year that's all about
                            stepping into your power and making your mark. Career-wise, you'll be a force to be
                            reckoned with. Your bold ideas and daring initiatives will catch the attention of the
                            right people, propelling you towards new heights. </p>
                        <div className="gi-pro-rat-price mb-[0] flex flex-col">
                            <Link to="/daily-horoscope-details"
                                className="text-[12px] uppercase border border-gray-400 text-gray-900 font-semibold px-6 py-2 hover:bg-gray-300 mt-4 mx-auto">View
                                More</Link>
                        </div>
                    </div>
                </div>
            </div>

            <div className="gi-product-content">
                <div
                    className="gi-product-inner transition-all duration-[0.3s] ease-in-out cursor-pointer overflow-hidden rounded-[5px] bg-white shadow-xl pt-4">
                    <div className="gi-pro-image-outer transition-all duration-[0.3s] delay-[0s] ease z-[11] relative">
                        <div className="gi-pro-image overflow-hidden pt-4 m-auto w-[120px] h-[120px]">
                            <Link to="/daily-horoscope-details"
                                className="image productimg7 relative block overflow-hidden pointer-events-none">
                                <img className="main-image max-w-full transition-all duration-[0.3s] ease delay-[0s]"
                                    src={Common_Images_Transport?.Taurus} alt="Product" />
                            </Link>
                        </div>
                    </div>
                    <div className="gi-pro-content h-full p-[20px] relative z-[10] flex flex-col text-center">

                        <Link to="/daily-horoscope-details">
                            <h5
                                className="gi-pro-stitle text-lg text-gray-900 font-semibold leading-[1.2] capitalize">
                                Taurus</h5>
                        </Link>
                        <p className="text-gray-700 font-medium text-[13px] leading-5 my-2 line-clamp-3">
                            Hey there, fiery Aries! Get ready to rock 2024 with unstoppable energy and fierce
                            determination. Your Aries Horoscope 2024 is a sneak peek into a year that's all about
                            stepping into your power and making your mark. Career-wise, you'll be a force to be
                            reckoned with. Your bold ideas and daring initiatives will catch the attention of the
                            right people, propelling you towards new heights. </p>
                        <div className="gi-pro-rat-price mb-[0] flex flex-col">
                            <Link to="/daily-horoscope-details"
                                className="text-[12px] uppercase border border-gray-400 text-gray-900 font-semibold px-6 py-2 hover:bg-gray-300 mt-4 mx-auto">View
                                More</Link>
                        </div>
                    </div>
                </div>
            </div>
            <div className="gi-product-content">
                <div
                    className="gi-product-inner transition-all duration-[0.3s] ease-in-out cursor-pointer overflow-hidden rounded-[5px] bg-white shadow-xl pt-4">
                    <div className="gi-pro-image-outer transition-all duration-[0.3s] delay-[0s] ease z-[11] relative">
                        <div className="gi-pro-image overflow-hidden pt-4 m-auto w-[120px] h-[120px]">
                            <Link to="/daily-horoscope-details"
                                className="image productimg7 relative block overflow-hidden pointer-events-none">
                                <img className="main-image max-w-full transition-all duration-[0.3s] ease delay-[0s]"
                                    src={Common_Images_Transport?.Gemini} alt="Product" />
                            </Link>
                        </div>
                    </div>
                    <div className="gi-pro-content h-full p-[20px] relative z-[10] flex flex-col text-center">
                        <Link to="/daily-horoscope-details">
                            <h5
                                className="gi-pro-stitle text-lg text-gray-900 font-semibold leading-[1.2] capitalize">
                                Gemini</h5>
                        </Link>
                        <p className="text-gray-700 font-medium text-[13px] leading-5 my-2 line-clamp-3">
                            Hey there, fiery Aries! Get ready to rock 2024 with unstoppable energy and fierce
                            determination. Your Aries Horoscope 2024 is a sneak peek into a year that's all about
                            stepping into your power and making your mark. Career-wise, you'll be a force to be
                            reckoned with. Your bold ideas and daring initiatives will catch the attention of the
                            right people, propelling you towards new heights. </p>
                        <div className="gi-pro-rat-price mb-[0] flex flex-col">
                            <Link to="/daily-horoscope-details"
                                className="text-[12px] uppercase border border-gray-400 text-gray-900 font-semibold px-6 py-2 hover:bg-gray-300 mt-4 mx-auto">View
                                More</Link>
                        </div>
                    </div>
                </div>
            </div>
            <div className="gi-product-content">
                <div
                    className="gi-product-inner transition-all duration-[0.3s] ease-in-out cursor-pointer overflow-hidden rounded-[5px] bg-white shadow-xl pt-4">
                    <div className="gi-pro-image-outer transition-all duration-[0.3s] delay-[0s] ease z-[11] relative">
                        <div className="gi-pro-image overflow-hidden pt-4 m-auto w-[120px] h-[120px]">
                            <Link to="/daily-horoscope-details"
                                className="image productimg7 relative block overflow-hidden pointer-events-none">
                                <img className="main-image max-w-full transition-all duration-[0.3s] ease delay-[0s]"
                                    src={Common_Images_Transport?.Cancer} alt="Product" />
                            </Link>
                        </div>
                    </div>
                    <div className="gi-pro-content h-full p-[20px] relative z-[10] flex flex-col text-center">
                        <Link to="/daily-horoscope-details">
                            <h5
                                className="gi-pro-stitle text-lg text-gray-900 font-semibold leading-[1.2] capitalize">
                                Cancer</h5>
                        </Link>
                        <p className="text-gray-700 font-medium text-[13px] leading-5 my-2 line-clamp-3">
                            Hey there, fiery Aries! Get ready to rock 2024 with unstoppable energy and fierce
                            determination. Your Aries Horoscope 2024 is a sneak peek into a year that's all about
                            stepping into your power and making your mark. Career-wise, you'll be a force to be
                            reckoned with. Your bold ideas and daring initiatives will catch the attention of the
                            right people, propelling you towards new heights. </p>
                        <div className="gi-pro-rat-price mb-[0] flex flex-col">
                            <Link to="/daily-horoscope-details"
                                className="text-[12px] uppercase border border-gray-400 text-gray-900 font-semibold px-6 py-2 hover:bg-gray-300 mt-4 mx-auto">View
                                More</Link>
                        </div>
                    </div>
                </div>
            </div>
            <div className="gi-product-content">
                <div
                    className="gi-product-inner transition-all duration-[0.3s] ease-in-out cursor-pointer overflow-hidden rounded-[5px] bg-white shadow-xl pt-4">
                    <div className="gi-pro-image-outer transition-all duration-[0.3s] delay-[0s] ease z-[11] relative">
                        <div className="gi-pro-image overflow-hidden pt-4 m-auto w-[120px] h-[120px]">
                            <Link to="/daily-horoscope-details"
                                className="image productimg7 relative block overflow-hidden pointer-events-none">
                                <img className="main-image max-w-full transition-all duration-[0.3s] ease delay-[0s]"
                                    src={Common_Images_Transport?.leo} alt="Product" />
                            </Link>
                        </div>
                    </div>
                    <div className="gi-pro-content h-full p-[20px] relative z-[10] flex flex-col text-center">
                        <Link to="/daily-horoscope-details">
                            <h5
                                className="gi-pro-stitle text-lg text-gray-900 font-semibold leading-[1.2] capitalize">
                                Leo</h5>
                        </Link>
                        <p className="text-gray-700 font-medium text-[13px] leading-5 my-2 line-clamp-3">
                            Hey there, fiery Aries! Get ready to rock 2024 with unstoppable energy and fierce
                            determination. Your Aries Horoscope 2024 is a sneak peek into a year that's all about
                            stepping into your power and making your mark. Career-wise, you'll be a force to be
                            reckoned with. Your bold ideas and daring initiatives will catch the attention of the
                            right people, propelling you towards new heights. </p>
                        <div className="gi-pro-rat-price mb-[0] flex flex-col">
                            <Link to="/daily-horoscope-details"
                                className="text-[12px] uppercase border border-gray-400 text-gray-900 font-semibold px-6 py-2 hover:bg-gray-300 mt-4 mx-auto">View
                                More</Link>
                        </div>
                    </div>
                </div>
            </div>
            <div className="gi-product-content">
                <div
                    className="gi-product-inner transition-all duration-[0.3s] ease-in-out cursor-pointer overflow-hidden rounded-[5px] bg-white shadow-xl pt-4">
                    <div className="gi-pro-image-outer transition-all duration-[0.3s] delay-[0s] ease z-[11] relative">
                        <div className="gi-pro-image overflow-hidden pt-4 m-auto w-[120px] h-[120px]">
                            <Link to="/daily-horoscope-details"
                                className="image productimg7 relative block overflow-hidden pointer-events-none">
                                <img className="main-image max-w-full transition-all duration-[0.3s] ease delay-[0s]"
                                    src={Common_Images_Transport?.Virgo} alt="Product" />
                            </Link>
                        </div>
                    </div>
                    <div className="gi-pro-content h-full p-[20px] relative z-[10] flex flex-col text-center">
                        <Link to="/daily-horoscope-details">
                            <h5
                                className="gi-pro-stitle text-lg text-gray-900 font-semibold leading-[1.2] capitalize">
                                Virgo</h5>
                        </Link>
                        <p className="text-gray-700 font-medium text-[13px] leading-5 my-2 line-clamp-3">
                            Hey there, fiery Aries! Get ready to rock 2024 with unstoppable energy and fierce
                            determination. Your Aries Horoscope 2024 is a sneak peek into a year that's all about
                            stepping into your power and making your mark. Career-wise, you'll be a force to be
                            reckoned with. Your bold ideas and daring initiatives will catch the attention of the
                            right people, propelling you towards new heights. </p>
                        <div className="gi-pro-rat-price mb-[0] flex flex-col">
                            <Link to="/daily-horoscope-details"
                                className="text-[12px] uppercase border border-gray-400 text-gray-900 font-semibold px-6 py-2 hover:bg-gray-300 mt-4 mx-auto">View
                                More</Link>
                        </div>
                    </div>
                </div>
            </div>
            <div className="gi-product-content">
                <div
                    className="gi-product-inner transition-all duration-[0.3s] ease-in-out cursor-pointer overflow-hidden rounded-[5px] bg-white shadow-xl pt-4">
                    <div className="gi-pro-image-outer transition-all duration-[0.3s] delay-[0s] ease z-[11] relative">
                        <div className="gi-pro-image overflow-hidden pt-4 m-auto w-[120px] h-[120px]">
                            <Link to="/daily-horoscope-details"
                                className="image productimg7 relative block overflow-hidden pointer-events-none">
                                <img className="main-image max-w-full transition-all duration-[0.3s] ease delay-[0s]"
                                    src={Common_Images_Transport?.Libra} alt="Product" />
                            </Link>
                        </div>
                    </div>
                    <div className="gi-pro-content h-full p-[20px] relative z-[10] flex flex-col text-center">
                        <Link to="/daily-horoscope-details">
                            <h5
                                className="gi-pro-stitle text-lg text-gray-900 font-semibold leading-[1.2] capitalize">
                                Libra</h5>
                        </Link>
                        <p className="text-gray-700 font-medium text-[13px] leading-5 my-2 line-clamp-3">
                            Hey there, fiery Aries! Get ready to rock 2024 with unstoppable energy and fierce
                            determination. Your Aries Horoscope 2024 is a sneak peek into a year that's all about
                            stepping into your power and making your mark. Career-wise, you'll be a force to be
                            reckoned with. Your bold ideas and daring initiatives will catch the attention of the
                            right people, propelling you towards new heights. </p>
                        <div className="gi-pro-rat-price mb-[0] flex flex-col">
                            <Link to="/daily-horoscope-details"
                                className="text-[12px] uppercase border border-gray-400 text-gray-900 font-semibold px-6 py-2 hover:bg-gray-300 mt-4 mx-auto">View
                                More</Link>
                        </div>
                    </div>
                </div>
            </div>
            <div className="gi-product-content">
                <div
                    className="gi-product-inner transition-all duration-[0.3s] ease-in-out cursor-pointer overflow-hidden rounded-[5px] bg-white shadow-xl pt-4">
                    <div className="gi-pro-image-outer transition-all duration-[0.3s] delay-[0s] ease z-[11] relative">
                        <div className="gi-pro-image overflow-hidden pt-4 m-auto w-[120px] h-[120px]">
                            <Link to="/daily-horoscope-details"
                                className="image productimg7 relative block overflow-hidden pointer-events-none">
                                <img className="main-image max-w-full transition-all duration-[0.3s] ease delay-[0s]"
                                    src={Common_Images_Transport?.Scorpio} alt="Product" />
                            </Link>
                        </div>
                    </div>
                    <div className="gi-pro-content h-full p-[20px] relative z-[10] flex flex-col text-center">
                        <Link to="/daily-horoscope-details">
                            <h5
                                className="gi-pro-stitle text-lg text-gray-900 font-semibold leading-[1.2] capitalize">
                                Scorpio</h5>
                        </Link>
                        <p className="text-gray-700 font-medium text-[13px] leading-5 my-2 line-clamp-3">
                            Hey there, fiery Aries! Get ready to rock 2024 with unstoppable energy and fierce
                            determination. Your Aries Horoscope 2024 is a sneak peek into a year that's all about
                            stepping into your power and making your mark. Career-wise, you'll be a force to be
                            reckoned with. Your bold ideas and daring initiatives will catch the attention of the
                            right people, propelling you towards new heights. </p>
                        <div className="gi-pro-rat-price mb-[0] flex flex-col">
                            <Link to="/daily-horoscope-details"
                                className="text-[12px] uppercase border border-gray-400 text-gray-900 font-semibold px-6 py-2 hover:bg-gray-300 mt-4 mx-auto">View
                                More</Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Similar_Daily_Horoscope